// Firebase Configuration
// This file initializes and exports Firebase services for the application

import { initializeApp } from 'firebase/app';
import { initializeFirestore, connectFirestoreEmulator, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration using environment variables for security
// Falls back to direct values if env vars are not set (for development)
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAQKFt7Rnl3TVQYJqkamPedUKtpnY4YwA4",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "finance-company-website.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "finance-company-website",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "finance-company-website.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "969615836250",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:969615836250:web:24554eb5d227c719390463",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ZG5CGL05B8"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database with long polling and persistence
// experimentalForceLongPolling fixes the 'INTERNAL ASSERTION FAILED: Unexpected state (ID: ca9)' error
export const db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
    })
});

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
const initAnalytics = async () => {
    if (await isSupported()) {
        analytics = getAnalytics(app);
    }
    return analytics;
};

// Initialize analytics
initAnalytics();

// Export analytics getter (async because it needs to check support)
export const getAnalyticsInstance = () => analytics;

// Connect to emulators in development (optional - uncomment if using Firebase emulators)
// if (process.env.NODE_ENV === 'development') {
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   connectStorageEmulator(storage, 'localhost', 9199);
// }

// Export the Firebase app instance
export default app;
